module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2026-02-16 at 21.42.50 (1) - Copy.ef8fc70f.jpeg";